import { render, staticRenderFns } from "./contract-update-view.vue?vue&type=template&id=a610267a&scoped=true"
import script from "./contract-update-view.vue?vue&type=script&lang=js"
export * from "./contract-update-view.vue?vue&type=script&lang=js"
import style0 from "./contract-update-view.vue?vue&type=style&index=0&id=a610267a&prod&scoped=true&lang=css"
import style1 from "./contract-update-view.vue?vue&type=style&index=1&id=a610267a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a610267a",
  null
  
)

export default component.exports